export const MARKET_ANALYSIS_POST_DESCRIPTION = 'Market analysis post.';

export const isMarketAnalysisPostPage = (description) =>
  description === MARKET_ANALYSIS_POST_DESCRIPTION;
